module.exports = __webpack_public_path__ + "static/media/hyperpay.f3b41818.jpeg";